import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { AnimationOptions } from 'ngx-lottie';
import HttpService from '../sharedServices/http.service';
import UserDataService from '../sharedServices/user-data.service';
import { Router } from '@angular/router';
import ManageImage from '../cellarbook/services/manage-images.service';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, debounceTime } from 'rxjs';
import LoadingIndicatorService from '../sharedServices/loading-indicator.service';

@Component({
  selector: 'app-home-new',
  templateUrl: './home-new.component.html',
  styleUrls: ['./home-new.component.css']
})
export class HomeNewComponent implements OnInit, AfterViewInit {
  isVideoPlaying = false;
  itemsPerSlide = 1;
  showCarousel = false;
  showCarouselOfOffers = false;
  wineSlides = [];
  wineArticles = [
    {
      title: 'Tresorvino Champagne Trip 2025',
      description: 'Each year, the team at Tresorvino embarks on a dedicated journey to the Champagne region of France to deepen their understanding and discover hidden gems.',
      imagePath: '../../assets/blogs/tresorvino-champagne.png',
    }
  ]
  openFaqIndex = 0;
  currentSection = '';
  mainFaqList = [];
  langCode = '';

  dashboardDeskOptions: AnimationOptions = {
    path: '/assets/homepage/dashboard/dashboard-desktop.json',
    renderer: 'svg'
  };
  dashboardMobileOptions: AnimationOptions = {
    path: '/assets/homepage/dashboard/dashboard-mobile.json',
    renderer: 'svg'
  };
  vinoDeskOptions: AnimationOptions = {
    path: '/assets/homepage/vino-coins/vino-coins-desktop.json',
    renderer: 'svg'
  };
  vinoMobileOptions: AnimationOptions = {
    path: '/assets/homepage/vino-coins/vino-coins-mobile.json',
    renderer: 'svg'
  };
  wineDeskOptions: AnimationOptions = {
    path: '/assets/homepage/wine-database/wine-database-desktop.json',
    renderer: 'svg'
  };
  wineMobileOptions: AnimationOptions = {
    path: '/assets/homepage/wine-database/wine-database-mobile.json',
    renderer: 'svg'
  };
  p2pDeskOptions: AnimationOptions = {
    path: '/assets/homepage/p2p/p2p-desktop.json',
    renderer: 'svg'
  };
  p2pMobileOptions: AnimationOptions = {
    path: '/assets/homepage/p2p/p2p-mobile.json',
    renderer: 'svg'
  };
  commDeskOptions: AnimationOptions = {
    path: '/assets/homepage/community/global-community-desktop.json',
    renderer: 'svg'
  };
  commMobileOptions: AnimationOptions = {
    path: '/assets/homepage/community/global-community-mobile.json',
    renderer: 'svg'
  };
  assetDeskOptions: AnimationOptions = {
    path: '/assets/homepage/asset-class/asset-class-desktop.json',
    renderer: 'svg'
  };
  assetMobileOptions: AnimationOptions = {
    path: '/assets/homepage/asset-class/asset-class-mobile.json',
    renderer: 'svg'
  };
  infoText: string = '';
  showInfoOverlay: boolean = false;
  searchControl = new FormControl();
  searchedText = '';
  backUpWineSlides = [];
  wineOffers = [];
  // wineOffers = [
  //   {
  //       "so_country": "fr",
  //       "so_color": "COL005",
  //       "sale_id": "0ca6b157-f465-4293-998e-6cb12ff77dca",
  //       "so_ask_price": "320",
  //       "so_updt_time": "2024-01-22 03:45:04",
  //       "wine_name": "calisse, calisse rouge, coteaux varois en provence",
  //       "so_vintage": "2014",
  //       "so_bottle_size": "BOS008",
  //       "so_crtd_time": "2024-01-22 03:45:04",
  //       "cellar_bk_id": "26b5f452-da69-4414-a1c2-3b5714e4c244",
  //       "so_updt_date": "22.01.2024",
  //       "so_wine_type": "",
  //       "user_id": "48d1786b-2536-4574-9b7f-d8fc9c24e649",
  //       "so_crtd_date": "22.01.2024",
  //       "global_wine_id": "LWIN-1140408",
  //       "so_region": "Provence",
  //       "user_wine_id": "e6928b37-01d6-43e9-963b-99874b12e2fa",
  //       "so_quantity": 1,
  //       "yearDiffernce": 11,
  //       "addressInfo": "{\"city\": \"Mumbai Suburban\", \"country\": \"IN\"}",
  //       "identityId": "eu-central-1:033450e8-fedc-4624-a32f-4d009ab10a65",
  //       "producer_name": "Calisse",
  //       "wine_type": "red wine",
  //       "region": "Provence",
  //       "country": "fr",
  //       "producer_title": null,
  //       "sub_region": "Coteaux Varois en Provence",
  //       "cw_description": "Lorem Ipsum \u0915\u094d\u092f\u093e \u0939\u0948?\nLorem Ipsum \u091b\u092a\u093e\u0908 \u0914\u0930 \u0905\u0915\u094d\u0937\u0930 \u092f\u094b\u091c\u0928 \u0909\u0926\u094d\u092f\u094b\u0917 \u0915\u093e \u090f\u0915 \u0938\u093e\u0927\u093e\u0930\u0923 \u0921\u092e\u0940 \u092a\u093e\u0920 \u0939\u0948. Lorem Ipsum \u0938\u0928 \u0967\u096b\u0966\u0966 \u0915\u0947 \u092c\u093e\u0926 \u0938\u0947 \u0905\u092d\u0940 \u0924\u0915 \u0907\u0938 \u0909\u0926\u094d\u092f\u094b\u0917 \u0915\u093e \u092e\u093e\u0928\u0915 \u0921\u092e\u0940 \u092a\u093e\u0920 \u092e\u0928 \u0917\u092f\u093e, \u091c\u092c \u090f\u0915 \u0905\u091c\u094d\u091e\u093e\u0924 \u092e\u0941\u0926\u094d\u0930\u0915 \u0928\u0947 \u0928\u092e\u0942\u0928\u093e \u0932\u0947\u0915\u0930 \u090f\u0915 \u0928\u092e\u0942\u0928\u093e \u0915\u093f\u0924\u093e\u092c \u092c\u0928\u093e\u0908. \u092f\u0939 \u0928 \u0915\u0947\u0935\u0932 \u092a\u093e\u0901\u091a \u0938\u0926\u093f\u092f\u094b\u0902 \u0938\u0947 \u091c\u0940\u0935\u093f\u0924 \u0930\u0939\u093e \u092c\u0932\u094d\u0915\u093f \u0907\u0938\u0928\u0947 \u0907\u0932\u0947\u0915\u094d\u091f\u094d\u0930\u0949\u0928\u093f\u0915 \u092e\u0940\u0921\u093f\u092f\u093e \u092e\u0947\u0902 \u091b\u0932\u093e\u0902\u0917 \u0932\u0917\u093e\u0928\u0947 \u0915\u0947 \u092c\u093e\u0926 \u092d\u0940 \u092e\u0942\u0932\u0924\u0903 \u0905\u092a\u0930\u093f\u0935\u0930\u094d\u0924\u093f\u0924 \u0930\u0939\u093e. \u092f\u0939 1960 \u0915\u0947 \u0926\u0936\u0915 \u092e\u0947\u0902 Letraset Lorem Ipsum \u0905\u0902\u0936 \u092f\u0941\u0915\u094d\u0924 \u092a\u0924\u094d\u0930 \u0915\u0947 \u0930\u093f\u0932\u0940\u091c \u0915\u0947 \u0938\u093e\u0925 \u0932\u094b\u0915\u092a\u094d\u0930\u093f\u092f \u0939\u0941\u0906, \u0914\u0930 \u0939\u093e\u0932 \u0939\u0940 \u092e\u0947\u0902 Aldus PageMaker Lorem Ipsum \u0915\u0947 \u0938\u0902\u0938\u094d\u0915\u0930\u0923\u094b\u0902 \u0938\u0939\u093f\u0924 \u0924\u0930\u0939 \u0921\u0947\u0938\u094d\u0915\u091f\u0949\u092a \u092a\u094d\u0930\u0915\u093e\u0936\u0928 \u0938\u0949\u092b\u094d\u091f\u0935\u0947\u092f\u0930 ",
  //       "cw_currency": "EUR",
  //       "cw_image": []
  //   },
  //   {
  //       "so_country": "fr",
  //       "so_color": "COL005",
  //       "sale_id": "9cc69407-7c38-4e96-89ec-a3163c47c382",
  //       "so_ask_price": "2000.00",
  //       "so_updt_time": "2024-11-17 12:09:42",
  //       "wine_name": "chantet blanet, puisseguin-saint-emilion",
  //       "so_vintage": "2010",
  //       "so_bottle_size": "BOS008",
  //       "so_crtd_time": "2024-11-17 12:09:42",
  //       "cellar_bk_id": "20fdd9d1-2f3e-4059-9dbc-3e0aa682dd04",
  //       "so_updt_date": "17.11.2024",
  //       "so_wine_type": "",
  //       "user_id": "48d1786b-2536-4574-9b7f-d8fc9c24e649",
  //       "so_crtd_date": "17.11.2024",
  //       "global_wine_id": "LWIN-1319327",
  //       "so_region": "Bordeaux",
  //       "user_wine_id": "0b380f55-e739-4517-85a4-5af2ba91121a",
  //       "so_quantity": 1,
  //       "yearDiffernce": 15,
  //       "addressInfo": "{\"city\": \"Mumbai Suburban\", \"country\": \"IN\"}",
  //       "identityId": "eu-central-1:033450e8-fedc-4624-a32f-4d009ab10a65",
  //       "producer_name": "Chantet Blanet",
  //       "wine_type": "red wine",
  //       "region": "Bordeaux",
  //       "country": "fr",
  //       "producer_title": null,
  //       "sub_region": "Puisseguin-Saint-Emilion",
  //       "cw_description": "Testing TRES-625",
  //       "cw_currency": "EUR",
  //       "cw_image": []
  //   },
  //   {
  //       "so_country": "za",
  //       "so_color": "COL005",
  //       "sale_id": "76228141-334f-4826-ad4f-641168fd615b",
  //       "so_ask_price": "1800",
  //       "so_updt_time": "2024-02-03 06:11:52",
  //       "wine_name": "rickety bridge, the printer's devil red, coastal region",
  //       "so_vintage": "2005",
  //       "so_bottle_size": "BOS009",
  //       "so_crtd_time": "2024-02-03 06:11:52",
  //       "cellar_bk_id": "26b5f452-da69-4414-a1c2-3b5714e4c244",
  //       "so_updt_date": "03.02.2024",
  //       "so_wine_type": "",
  //       "user_id": "48d1786b-2536-4574-9b7f-d8fc9c24e649",
  //       "so_crtd_date": "03.02.2024",
  //       "global_wine_id": "LWIN-2034614",
  //       "so_region": "Coastal Region",
  //       "user_wine_id": "b4e1f97d-8bf3-410d-9490-a0d6e6b9593e",
  //       "so_quantity": 1,
  //       "yearDiffernce": 20,
  //       "addressInfo": "{\"city\": \"Mumbai Suburban\", \"country\": \"IN\"}",
  //       "identityId": "eu-central-1:033450e8-fedc-4624-a32f-4d009ab10a65",
  //       "producer_name": "Rickety Bridge",
  //       "wine_type": "red wine",
  //       "region": "Coastal Region",
  //       "country": "za",
  //       "producer_title": null,
  //       "sub_region": null,
  //       "cw_description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ",
  //       "cw_currency": "EUR",
  //       "cw_image": []
  //   },
  //   {
  //       "so_country": "fr",
  //       "so_color": "",
  //       "sale_id": "7ae173d9-b291-4ba2-8e1e-e46f42c64733",
  //       "so_ask_price": "600.00",
  //       "so_updt_time": "2024-07-15 14:07:11",
  //       "wine_name": "ott (clos mireille), blanc de blancs, cotes de provence",
  //       "so_vintage": "2005",
  //       "so_bottle_size": "BOS008",
  //       "so_crtd_time": "2024-07-15 14:07:11",
  //       "cellar_bk_id": "1ab25f28-acf2-49fd-a712-7b911b1587de",
  //       "so_updt_date": "15.07.2024",
  //       "so_wine_type": "",
  //       "user_id": "48d1786b-2536-4574-9b7f-d8fc9c24e649",
  //       "so_crtd_date": "15.07.2024",
  //       "global_wine_id": "LWIN-1263457",
  //       "so_region": "Provence",
  //       "user_wine_id": "d12b63b8-e146-4b16-b92d-c019374ce11a",
  //       "so_quantity": 3,
  //       "yearDiffernce": 20,
  //       "addressInfo": "{\"city\": \"Dhule\", \"country\": \"IN\"}",
  //       "identityId": "eu-central-1:0419335a-cf42-4608-b362-8982fb562e8c",
  //       "producer_name": "Ott (Clos Mireille)",
  //       "wine_type": "white wine",
  //       "region": "Provence",
  //       "country": "fr",
  //       "producer_title": null,
  //       "sub_region": "Cotes de Provence",
  //       "cw_description": "isque risus purus vel tellus. Nulla facilisi. Nunc ac ullamcorper risus. Nulla porttitor elit urna, ac varius arcu semper vel. Aenean mollis faucibus elit et scelerisque. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Phasellus ornare euismod leo suscipit suscipit. Maecenas tincidunt nisi tellus, in convallis felis scelerisque vel. Nunc at imperdiet tellus. Morbi consequat libero vel mauris commodo condimentum. Sed non dignissim sem. Aenean eu orci erat. D",
  //       "cw_currency": "EUR",
  //       "cw_image": []
  //   },
  //   {
  //       "so_country": "fr",
  //       "so_color": "",
  //       "sale_id": "602986e6-d920-453e-b3fb-5cb825232af2",
  //       "so_ask_price": "500.00",
  //       "so_updt_time": "2024-11-20 13:28:00",
  //       "wine_name": "domaine bois de boursan, chateauneuf-du-pape, blanc",
  //       "so_vintage": "2010",
  //       "so_bottle_size": "BOS010",
  //       "so_crtd_time": "2024-06-02 12:51:21",
  //       "cellar_bk_id": "26b5f452-da69-4414-a1c2-3b5714e4c244",
  //       "so_updt_date": "20.11.2024",
  //       "so_wine_type": "",
  //       "user_id": "48d1786b-2536-4574-9b7f-d8fc9c24e649",
  //       "so_crtd_date": "02.06.2024",
  //       "global_wine_id": "LWIN-1108752",
  //       "so_region": "Rhone",
  //       "user_wine_id": "13758b4d-9f11-43fd-bc40-01860c021cec",
  //       "so_quantity": 1,
  //       "yearDiffernce": 15,
  //       "addressInfo": "{\"city\": \"Mumbai Suburban\", \"country\": \"IN\"}",
  //       "identityId": "eu-central-1:033450e8-fedc-4624-a32f-4d009ab10a65",
  //       "producer_name": "Bois de Boursan",
  //       "wine_type": "white wine",
  //       "region": "Rhone",
  //       "country": "fr",
  //       "producer_title": "Domaine",
  //       "sub_region": "Chateauneuf-du-Pape",
  //       "cw_description": null,
  //       "cw_currency": "EUR",
  //       "cw_image": []
  //   },
  //   {
  //       "so_country": "fr",
  //       "so_color": "",
  //       "sale_id": "9d90d707-9c14-4e32-ad79-7c93fa25e886",
  //       "so_ask_price": "500.00",
  //       "so_updt_time": "2024-04-07 05:32:06",
  //       "wine_name": "mas de boislauzon, chateauneuf-du-pape, blanc",
  //       "so_vintage": "2009",
  //       "so_bottle_size": "BOS012",
  //       "so_crtd_time": "2024-04-07 05:32:06",
  //       "cellar_bk_id": "20fdd9d1-2f3e-4059-9dbc-3e0aa682dd04",
  //       "so_updt_date": "07.04.2024",
  //       "so_wine_type": "",
  //       "user_id": "48d1786b-2536-4574-9b7f-d8fc9c24e649",
  //       "so_crtd_date": "07.04.2024",
  //       "global_wine_id": "LWIN-1108808",
  //       "so_region": "Rhone",
  //       "user_wine_id": "7a30f6ef-7293-4d54-8c7d-310b9364ca55",
  //       "so_quantity": 1,
  //       "yearDiffernce": 16,
  //       "addressInfo": "{\"city\": \"Mumbai Suburban\", \"country\": \"IN\"}",
  //       "identityId": "eu-central-1:033450e8-fedc-4624-a32f-4d009ab10a65",
  //       "producer_name": "Mas de Boislauzon",
  //       "wine_type": "white wine",
  //       "region": "Rhone",
  //       "country": "fr",
  //       "producer_title": null,
  //       "sub_region": "Chateauneuf-du-Pape",
  //       "cw_description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ",
  //       "cw_currency": "EUR",
  //       "cw_image": []
  //   }
  // ];
  wineImages: any = [
    {
      wineId: "48d1786b-2536-4574-9b7f-d8fc9c24e649",
      images: ["../../assets/img/red-wine-bottle.jpg"]
    }
  ];
  wineList$ = new BehaviorSubject([]);
  wineImages$ = new BehaviorSubject([]);
  showWineImages = false;
  carouselImages: any = [];
  showCarouselOverlay: boolean = false;
  visibleCount = 10;
  onSearch = false;
  isLoading = true;
  isReady = false;
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public translate: TranslateService,
    private httpService: HttpService,
    private userDataService: UserDataService,
    private router: Router,
    private manageImage: ManageImage,
    public loadingIndicator: LoadingIndicatorService,
  ) {
    this.titleService.setTitle('TresorVino - The Premier Platform for Fine Wine Trading and Investment');
    this.metaService.updateTag({ name: 'description', content: 'Join TresorVino, the ultimate destination for wine collectors and enthusiasts. Trade rare and fine wines, manage your collection with ease, and connect with a global community of connoisseurs. Explore curated selections, track wine investments, and earn rewards with Vino Coins.' });
  }

  ngOnInit(): void {
    // this.loadingIndicator.show();
    this.wineImages$.next(this.wineImages);
    this.wineList$.next(this.wineOffers.slice(0, this.visibleCount));
    if (!this.router.url.includes('#')) {
      window.scrollTo(0, 0);
    }
    if (window.innerWidth >= 768) {
      this.itemsPerSlide = 3;
    }
    this.setFaqData();
    this.translate.onLangChange.subscribe((data) => {
      this.setFaqData();
      this.langCode = data.lang;
    });
    this.langCode = this.userDataService.getLanguage();
    if (!this.langCode) {
      this.langCode = 'EN';
    }
    this.getFinestWines();
    this.searchControl.valueChanges
    .pipe(
      debounceTime(400)
    )
    .subscribe(event => {
      this.visibleCount = 10;
      let text = this.searchedText.toLowerCase().trim();
      this.wineSlides = this.wineOffers;
      if (text) {
        this.onSearch = true;
        this.wineSlides = this.wineSlides.filter((item: any) => item?.wine_name?.toLowerCase()?.includes(text) || item?.cw_description?.toLowerCase()?.includes(text));
        this.wineList$.next(this.wineSlides.slice(0, this.visibleCount));
      } else {
        this.wineList$.next(this.wineSlides.slice(0, this.visibleCount));
        this.onSearch = false;
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 768 && this.itemsPerSlide === 3) {
      this.showCarousel = false;
      this.itemsPerSlide = 1;
      setTimeout(() => {
        this.showCarousel = true;
      }, 50);
    } else if (event.target.innerWidth >= 768 && this.itemsPerSlide === 1) {
      this.showCarousel = false;
      this.itemsPerSlide = 3;
      setTimeout(() => {
        this.showCarousel = true;
      }, 50);
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    const sections = document.querySelectorAll('.desktop-lottie-section .feature-video');
    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      const sectionId = section.id;
      if (rect.top >= 0 && rect.top <= window.innerHeight / 2) {
      // if (rect.top >= 0 && rect.top <= 250) {
        this.currentSection = sectionId;
      }
    });
  }

  async getFinestWines() {
    this.httpService.getFinestWineOffers().subscribe((data: any) => {
      this.wineOffers = [...data];
      this.wineList$.next(this.wineOffers.slice(0, this.visibleCount));
      this.getWineImages();
      this.backUpWineSlides = this.wineSlides;
      this.showCarouselOfOffers = true;
      this.isLoading = false;
      this.isReady = true;
    })
  }

  getWineImages() {
    this.wineOffers.forEach(async (wine) => {
      if (wine?.cw_image?.length) {
        const imageKeys = wine.cw_image;
        // this.loadingIndicator.show();
        this.manageImage.getProtectedImages(imageKeys, wine.identityId)
        .then((response) => {
          this.showWineImages = false;
          this.wineImages.push({
            wineId: wine.user_wine_id,
            images: response
          });
          this.wineImages$.next(this.wineImages);
          setTimeout(() => {
            this.showWineImages = true;
          }, 1000);
          // this.loadingIndicator.hide();
        })
        .catch((error) => {
          console.log(error);
        });
      } else {
        this.showWineImages = false;
        let wineImage = '../../assets/img/red-wine-bottle.jpg';
        if (wine.wine_type.toLowerCase().includes('red')) {
          wineImage = '../../assets/img/red-wine-bottle.jpg';
        } else if (wine.wine_type.toLowerCase().includes('rose')) {
          wineImage = '../../assets/img/rose-wine-bottle.jpg';
        } else if (wine.wine_type.toLowerCase().includes('white')) {
          wineImage = '../../assets/img/white-wine-bottle.jpg';
        } else if (wine.wine_type.toLowerCase().includes('mixed')) {
          wineImage = '../../assets/img/red-wine-bottle.jpg';
        }
        this.wineImages.push({
          wineId: wine.user_wine_id,
          images: [wineImage]
        });
        this.wineImages$.next(this.wineImages);
        setTimeout(() => {
          this.showWineImages = true;
        }, 1000);
      }
    });
  }

  setFaqData(): void {
    this.mainFaqList = [
      {
        question: this.translate.instant('faqs.question_1'),
        answer: this.translate.instant('faqs.answer_1')
      },
      // {
      //   question: this.translate.instant('faqs.question_2'),
      //   answer: this.translate.instant('faqs.answer_2')
      // },
      {
        question: this.translate.instant('faqs.question_3'),
        answer: this.translate.instant('faqs.answer_3')
      },
      {
        question: this.translate.instant('faqs.question_4'),
        answer: this.translate.instant('faqs.answer_4')
      },
      {
        question: this.translate.instant('faqs.question_5'),
        answer: this.translate.instant('faqs.answer_5')
      }
    ];
  }

  ngAfterViewInit() {
    setTimeout(() => {      
      // Create an IntersectionObserver instance
      // const observer = new IntersectionObserver(
      //   (entries) => {
      //     entries.forEach((entry) => {
      //       const video: HTMLVideoElement = document.getElementById("home-video") as any;
  
      //       if (entry.isIntersecting && video.paused) {
      //         // Play video when section comes into view
      //         video.pause();
      //         this.isVideoPlaying = true;
      //       } else {
      //         video.pause();
      //         this.isVideoPlaying = false;
      //       }
      //     });
      //   },
      //   {
      //     threshold: 0.5 // Play when at least 50% of the section is in view
      //   }
      // );
      
      // Observe the section with the video
      // const videoSection = document.querySelector('.video-container');
      // if (videoSection) {
      //   observer.observe(videoSection);
      // }
    }, 2000);
  }

  togglePlayPause(): void {
    const video = document.getElementById("home-video") as any;
    // const playPauseButton = document.querySelector(".play-pause-button");
    if (video.paused) {
      video.play();
      this.isVideoPlaying = true;
      // playPauseButton.textContent = "Pause";
    } else {
      video.pause();
      this.isVideoPlaying = false;
      // playPauseButton.textContent = "Play";
    }
  }

  openAccordion(index: number): void {
    if (this.openFaqIndex === index) {
      this.openFaqIndex = -1;
    } else {
      this.openFaqIndex = index;
    }
  }

  onInfoOverlayClose(): void {
    this.infoText = '';
    this.showInfoOverlay = false;
  }

  showAllDescription(description: string): void {
    this.infoText = description;
    this.showInfoOverlay = true;
  }
    
  showCarouselImages(wineId: string): void {
    const carouselImages = this.wineImages.find((item: any) => wineId === item.wineId);
    this.carouselImages = carouselImages.images;
    this.showCarouselOverlay = true;
  }

  hideCarouselOverlay(): void {
    this.showCarouselOverlay = false;
    this.carouselImages = [];
  }

  loadMore() {
    this.visibleCount += 6; 
    this.wineList$.next(this.wineOffers.slice(0, this.visibleCount));
  }

  loadMoreOnSearch() {
    this.visibleCount += 6; 
    this.wineList$.next(this.wineSlides.slice(0, this.visibleCount));
  }
}
